<template>
  <div>
    <tree-list ref="list" @load="load" @add="add" />
    <tree-composer
      style="margin-top:15px"
      ref="composer"
      @updated="updated"
      @deleted="deleted"
      v-show="show_composer"
    />
  </div>
</template>

<script>
import filters from "@/filters";
import TreeComposer from "./tree_composer/TreeComposer";
import TreeList from "./TreeList";

export default {
  name: "Feedback360Index",
  components: {
    TreeComposer,
    TreeList,
  },
  filters: filters,
  data() {
    return {
      show_composer: false,
    };
  },
  computed: {},
  methods: {
    load(chart) {
      this.$refs.composer.load(chart);
      this.show_composer = true;
    },
    updated(/* chart */) {
      this.$refs.list.init();
    },
    deleted(uuid) {
      this.$refs.list.delete(uuid);
      this.show_composer = false;
    },
    add() {
      this.show_composer = true;
      this.$refs.composer.create();
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style></style>
